import {
  jb_radio_css_default
} from "./chunk.J7WCMCZ2.js";
import {
  FormElement
} from "./chunk.MEO2C6ZS.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-radio/jb-radio.ts
var JbRadio = class extends Initiable(FormElement(r)) {
  _handleInputChange(e) {
    this.value = e.target.value;
  }
  _handleKeyDown(e) {
    if (e.code === "Space" || e.code === "Enter") {
      e.target.click();
      e.preventDefault();
    }
  }
  render() {
    return ke`
      <div class="${Rt({ error: !!this.errorText || this.showError, disabled: !!this.disabled })}">
        ${this.label ? ke`<label class="main">${this.label}${this.requiredText ? "*" : ""}</label>` : D}
        <div
          class="radios"
          role="radiogroup"
          aria-label="${this.label}"
          aria-invalid="${this.showError || this.errorText ? "true" : "false"}"
          aria-errormessage=${this.showError || !!this.errorText ? `${this.name}_error` : D}
          aria-required=${!!this.requiredText}
        >
          ${this.options.map(
      (option) => ke`
              <label>
                <input
                  .value=${option.value}
                  type="radio"
                  name="${this.name}"
                  ?checked="${option.value === this.value}"
                  ?required=${!!this.requiredText}
                  ?disabled=${this.disabled}
                  @change=${this._handleInputChange}
                  aria-label="${option.label}"
                  aria-checked="${option.value === this.value}"
                />
                <p
                  tabindex="0"
                  @keydown=${this._handleKeyDown}
                >
                  ${option.label}
                </p>
              </label>
            `
    )}
        </div>
        <div
          aria-live="polite"
          id="${this.name}_error"
        >
          ${this.showError ? ke`<p class="error">${this.requiredText}</p>` : D}
          ${this.errorText ? ke`<p class="error">${this.errorText}</p>` : D}
        </div>
      </div>
    `;
  }
};
JbRadio.styles = jb_radio_css_default;
JbRadio.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Array })
], JbRadio.prototype, "options", 2);
JbRadio = __decorateClass([
  customElement("jb-radio")
], JbRadio);

export {
  JbRadio
};
